import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import useTrans from "@hooks/translation";
import {inArray, is_array, ObjectLength} from "@helpers/arrays";
import {isEmpty} from "@helpers/helpers";
import {GetAgeUnit} from "@helpers/numbers";
import {sortPropertyFeatures} from "../helpers/features_helpers";

function Features({property}) {
    const [propertyFeatures, setPropertyFeatures] = useState([]);

    useEffect(() => {
        const {features} = property;
        let items = [];

        if (ObjectLength(features) > 0) {
            Object.keys(features).forEach(key => {
                let feature = features[key];

                if (!isEmpty(feature) && !inArray(key, ['facilities', 'dengue'])) {

                    let name = useTrans('property.' + key);
                    let value = '';


                    if (inArray(key, ['deed', 'dengue'])) {
                        name = useTrans('property.deed');

                        if (!isEmpty(property.dengue)) {
                            value = useTrans('property_attribute.dengue', {value: property.dengue});
                        }

                        if (!isEmpty(features.deed)) {
                            value += ' ' + useTrans('property_attribute.deed', {value: useTrans('property_deed.' + features.deed)})
                        }
                    } else if (inArray(key, ['front', 'position', 'cabinet', 'flooring', 'density', 'business_permit', 'construction_permit', 'instruction_phase'])) {
                        value = useTrans('property_attribute.' + key, {value: useTrans('property_' + key + '.' + feature)})
                    } else if (inArray(key, ['in_use', 'with_landlord'])) {
                        name = '';
                        if (!isEmpty(feature) && feature !== 0) {
                            name = useTrans('property.' + key);
                            value = useTrans('property_attribute.resides', {value: ''});
                        }
                    } else if (inArray(key, ['unit_per_floor'])) {

                        let temp = '';
                        if (feature === 1) {
                            temp = 'تک';
                        } else if (feature > 8) {
                            temp = ' 8+ ';
                        } else {
                            temp = feature;
                        }

                        value = useTrans('property_attribute.' + key, {value: temp});
                    } else if (key === 'floor') {
                        if (!is_array(feature)) {
                            feature = [feature]
                        }

                        let floors = [];

                        Object.keys(feature).forEach(k => {
                            const floor = feature[k];
                            floors.push(useTrans('property_floor.' + floor))
                        });

                        value = useTrans('property_attribute.' + key, {value: floors.join('، ')});
                    } else if (key === 'unit_type') {
                        value = useTrans('property_attribute.' + key, {value: useTrans('property.unit_type_' + feature)});
                    } else if (key === 'floor_count') {
                        value = useTrans('property_attribute.' + key, {value: (feature >= 36) ? '35+' : feature});
                    } else if (key === 'age') {
                        const age = GetAgeUnit(feature);
                        value = age.num + (!isEmpty(age.unit) ? ' ' + age.unit : '')
                    } else if (key === 'bedroom_count') {
                        if (inArray(property.type, ['apartment', 'house', 'villa', 'garden', 'suite', 'hotel', 'apartment_hotel', 'residential_complex'])) {
                            value = useTrans('property_attribute.bedroom_count', {value: feature}); // خواب
                        } else {
                            value = useTrans('property_attribute.room_count', {value: feature}); // اتاق
                            name = useTrans('property.room_count');
                        }
                    } else {
                        value = useTrans('property_attribute.' + key, {value: feature});
                    }

                    if (!isEmpty(name) && !isEmpty(value)) {
                        items.push({name: name, value: value, feature: key})
                    }
                }
            });

            setPropertyFeatures(sortPropertyFeatures(items))
        }
    }, []);

    return (
        <React.Fragment>
            <h2>اطلاعات اصلی</h2>
            <div className="mt-8 row">
                {
                    propertyFeatures.map((item, key) =>
                        (!isEmpty(item) && !isEmpty(item.name)) ?
                            <Item className="mt-8 mt-lg-16 col-md-4" key={key}>
                                <span>{item.name}: </span>
                                <span className="font-weight-bold">{item.value}</span>
                            </Item>
                            : ''
                    )
                }
            </div>
        </React.Fragment>
    )
}

export default React.memo(Features);

// styles
const Item = styled.div`
    @media (max-width: ${props => props.theme.screenXsMax}) {
        display: flex;
        /*align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;
        padding: 8px 0;*/
        span:first-child {
            flex: .35;
        }
       span:last-child {
            flex: 1;
       }
       
      
    }
`;